import { GuestDay, GuestSchedule } from './guest-attendance.types';

export const registrationFields = [
  {key:'organization', property:'organizationId', label:'所属'},
  {key:'ageBand', property:'ageBand', label:'年代'},
  {key:'gender', property:'gender', label:'性別'},
  {key:'firstEvent', property:'firstEvent', label:'組合の行事への初参加'},
  {key:'memberType', property:'memberType', label:'参加者区分'},
  {key:'address', property:'address', label:'住所'},
  {key:'email', property:'email', label:'メールアドレス'},
  {key:'phone', property:'phone', label:'電話番号'},
];

export const missingAnswer = (value:any):boolean => value == null ||
  (typeof value === 'string' && !value.trim()) || (Array.isArray(value) && !value.length);

// API timestamps without an offset are Japan local time, regardless of the viewer's timezone.
export function japanTime(value?:string):number {
  if(!value) return NaN;
  const iso=value.replace(' ','T');
  return Date.parse(/[zZ]|[+-]\d{2}:\d{2}$/.test(iso)?iso:iso+'+09:00');
}

export function receptionMessage(schedule:GuestSchedule, day:GuestDay, now=Date.now()):string {
  const start=day.receptionStart || (schedule.kind==='period'?schedule.receptionStart:day.startAt);
  const end=day.receptionEnd || (schedule.kind==='period'?schedule.receptionEnd:day.endAt);
  if(Number.isFinite(japanTime(start)) && now<japanTime(start)) return '受付開始前です。';
  if(Number.isFinite(japanTime(end)) && now>=japanTime(end)) return '受付期間は終了しました。';
  return day.canSelfCheckin===false ? '現在は参加登録できません。画面を再読み込みしてください。' : '';
}

export function canChangeDay(day:GuestDay, selected:boolean, locked:boolean, now=Date.now()):boolean {
  if(locked || day.canChange===false || (day.changeDeadline && now>=japanTime(day.changeDeadline))) return false;
  return selected || (day.canApply!==false && day.remaining!==0 &&
    (!day.registrationStart || now>=japanTime(day.registrationStart)) &&
    (!day.registrationEnd || now<japanTime(day.registrationEnd)));
}

export function questionError(q:any,value:any):string {
  if(q.policy==='off') return '';
  if(missingAnswer(value)) return q.policy==='required'?'回答してください。':'';
  if(q.type==='number' && (typeof value!=='number'||!Number.isFinite(value))) return '数値を入力してください。';
  if(q.type==='date' && !/^\d{4}-\d{2}-\d{2}$/.test(value)) return '日付を入力してください。';
  if(q.type==='rating' && ![1,2,3,4,5,'na'].includes(value)) return '評価を選択してください。';
  if(q.type==='single' && !q.options.includes(value)) return '選択肢を確認してください。';
  if(q.type==='multiple' && (!Array.isArray(value)||value.some(v=>!q.options.includes(v)))) return '選択肢を確認してください。';
  return '';
}
